// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "会计基础",
      "tec": "刘英杰",
      "week": "1-12周",
      "add": "教学楼D座221经管"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "精益生产",
      "tec": "郭艳秋",
      "week": "1-12周",
      "add": "教学楼D座213经管"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "管理创新思维与方法",
      "tec": "徐鸣哲",
      "week": "1-12周",
      "add": "教学楼D座222经管"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "管理创新思维与方法",
        "tec": "徐鸣哲",
        "week": "1-4周",
        "add": "教学楼D座221经管"
      },
      {
        "sub": "精益生产",
        "tec": "郭艳秋",
        "week": "5-8周",
        "add": "教学楼D座221经管"
      }
    ],
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
